// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "MediumPosts-module--bx--text-truncate--end--2QkVt";
export var bxTextTruncateFront = "MediumPosts-module--bx--text-truncate--front--c-mPy";
export var cardContainer = "MediumPosts-module--card-container--yfY7h";
export var image = "MediumPosts-module--image--mJKnv";